import React, { useContext, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { TextField } from '@material-ui/core';
import Button from '../../../../../../components/Button/ProgressiveButton';
import { RulesContext } from './RulesProvider';
import { TYPES, useValidator } from '../../../../../../hooks/useValidator';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
    height:'fit-content'
  },
  buttons: {
    display: 'flex',
  },
}));

const Form = () => {
  const classes = useStyles();
  const {
    rule,
    changeTextField,
    createRule,
    editRule,
    resetForm,
    showError,
    inProgress,
    mode,
  } = useContext(RulesContext);
  const { description, slug, routes, _id } = rule;
  const { category } = useParams();
  const validators = {
    description: [{ type: TYPES.REQUIRED }],
    slug: [{ type: TYPES.REQUIRED }],
  };
  const [errors, validate] = useValidator(validators);

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (validate({ description, slug })) {
      if (mode === 'add') createRule({ description, slug, routes, category });
      else editRule({ description, slug, routes, category, _id });
    } else {
      showError('خطاهای مشخص شده را رفع نمایید');
    }
  };

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <TextField
        value={description || ''}
        onChange={changeTextField}
        variant="outlined"
        size="medium"
        name="description"
        placeholder="نام دسترسی"
        error={errors?.description}
        helperText={errors?.description ? 'نام دسترسی بایستی وارد شود' : ''}
        onBlur={validate}
      />
      <TextField
        value={slug || ''}
        onChange={changeTextField}
        variant="outlined"
        size="medium"
        name="slug"
        placeholder="Slug"
        error={errors?.slug}
        helperText={errors?.slug ? 'slug بایستی وارد شود.' : ''}
        onBlur={validate}
      />
      <TextField
        value={routes || ''}
        onChange={changeTextField}
        variant="outlined"
        size="medium"
        name="routes"
        placeholder="Route Addresses"
        multiline
        rows={22}
        style={{ direction: 'ltr' }}
        error={errors?.routes}
        helperText={errors?.routes ? 'حداقل یک روت بایستی وارد شود.' : ''}
        onBlur={validate}
      />
      <div className={classes.buttons}>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="secondary"
          size="medium"
          disabled={inProgress}
          style={{ flex: 5 }}
        >
          {mode === 'add' ? 'افزودن' : 'ویرایش'}
        </Button>
        {mode === 'edit' && (
          <Button
            onClick={resetForm}
            variant="text"
            color="primary"
            size="medium"
            style={{ flex: 1 }}
          >
            صرفنظر
          </Button>
        )}
      </div>
    </form>
  );
};

export default React.memo(Form);
